import { Routes, Route } from "react-router-dom"
import { useQuery } from "@tanstack/react-query"
import { Calendar } from "lucide-react"
import { StatsCard } from "@/components/dashboard/StatsCard"
import { getAnonEvents } from "@/lib/queries/events"
import { UpcomingEventsTable } from "@/components/dashboard/UpcomingEventsTable"
import ProfilePage from "@/pages/profile/ProfilePage"
import EventDetails from "@/pages/events/EventDetails"

export const AnonDashboardOverview = ({ session, profile }: { session: any; profile: any }) => {

  const { data: stats } = useQuery({
    queryKey: ["anon-dashboard-stats", profile?.id],
    queryFn: () => ({ totalEvents: 0 }),
    enabled: !!profile?.id,
  })

  const { data: events } = useQuery({
    queryKey: ["anon-upcoming-events", profile?.id],
    queryFn: () => getAnonEvents(profile?.id),
    enabled: !!profile?.id,
  })

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <h2 className="text-3xl font-bold tracking-tight">My Events</h2>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        <StatsCard
          title="Registered Events"
          value={stats?.totalEvents || 0}
          icon={Calendar}
        />
      </div>

      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-medium">Upcoming Events</h3>
        </div>
        {events && events.length > 0 ? (
          <UpcomingEventsTable events={events} />
        ) : (
          <div className="rounded-lg border border-dashed p-8 text-center">
            <h3 className="text-lg font-medium">No Events Found</h3>
            <p className="text-sm text-gray-500 mt-1">
              You haven't registered for any events yet.
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export const AnonDashboardContent = ({ session, profile }: { session: any; profile: any }) => (
  <Routes>
    <Route index element={<AnonDashboardOverview session={session} profile={profile} />} />
    <Route path="events" element={<AnonDashboardOverview session={session} profile={profile} />} />
    <Route path="events/:id" element={<EventDetails session={session} profile={profile} />} />
    <Route path="profile" element={<ProfilePage session={session} profile={profile} />} />
  </Routes>
)
